import { useState, useCallback } from 'react';

const useUpload = (validateFile, invalidFileNotification, onError) => {
	const [result, setResult] = useState('');
	const [fileList, setFileList] = useState([]);

	const beforeUpload = useCallback(file => {
		setFileList([]);
		setResult('');
		if (typeof validateFile === 'function' && !validateFile(file)
			&& typeof invalidFileNotification === 'function') {
			invalidFileNotification();
			return false;
		}
		return true;
	}, [validateFile, invalidFileNotification]);

	const onChange = useCallback(info => {
		if (info.file.status) {
			setFileList([info.file]);
		}
		if (info.file.status === 'done' && info.file.response) {
			setResult(info.file.response);
		}
		if (info.file.status === 'error') {
			if (onError && typeof onError === 'function') {
				onError(info.file.name);
			}
		}
	}, [onError]);
	return [
		fileList,
		result,
		beforeUpload,
		onChange
	];
};

export default useUpload;



// WEBPACK FOOTER //
// ./src/hooks/UseUpload.js